import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-base-lock-filled",
  "use": "rt-base-lock-filled-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-base-lock-filled\"><defs><style type=\"text/css\"></style></defs><path d=\"M880 384H764V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v144H144c-17.7 0-32 14.3-32 32v464c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32zM542.3 662.1v57.3c0 4.8-3.9 8.6-8.7 8.6h-43.3c-4.8 0-8.7-3.9-8.7-8.6v-57.3c-13.1-9.4-21.7-24.8-21.7-42.2 0-28.6 23.3-51.9 52-51.9s52 23.2 52 51.9c0.1 17.4-8.5 32.7-21.6 42.2zM692 384H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v144z\" p-id=\"1547\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/lock-filled.svg
// module id = 1758
// module chunks = 137